import { User } from "../../entities/User";
import { get, set } from "./localStorage";

export const setLoginData = async (payload: User) => {
  return set("login", payload);
};

export const getLoginData = (): User => {
  return get("login") as User;
};

export const removeLoginData = async () => {
  if (!localStorage) {
    return;
  }
  try {
    localStorage.removeItem("login");
  } catch (error) {
    throw new Error("store deserialization failed");
  }
};
